<template>
  <div class="main-content" id="panel">
    <!-- HEADER -->
    <div class="header bg-primary pb-6">
      <div class="container-fluid">
        <div class="header-body">
          <div class="row align-items-center py-4">
            <div class="col-lg-6 col-7">
              <h2 class="text-white">De Minimis Calculator</h2>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- BODY -->
    <div class="container-fluid mt--6">
      <div class="row justify-content-md-center">
        <div class="col-xl-10">
          <div class="card shadow">
            <div class="card-header bg-transparent">
              <h5 class="mb-0">Enter Details</h5>
            </div>

            <div class="card-body">
              <!-- FORM -->
              <div class="form-row">
                
                <!-- ROW 1 -->
                <div class="form-group col-md-3">
                  <label>CUSIP</label>
                  <input v-model="form.cusip" class="form-control" placeholder="CUSIP"/>
                </div>

                <div class="form-group col-md-2">
                  <label>Price</label>
                  <input v-model="form.price" type="number" class="form-control" placeholder="$0.00" />
                </div>

             
                <div class="form-group col-md-3 tax-cal">
                  <label>Settlement Date</label>
                  <datepicker
                    v-model="form.settlementDate"
                    placeholder="mm/dd/yyyy"                    
                    name="settlementDate" 
                    format="MM/dd/yyyy" 
                    :clear-button="true" 
                    :calendar-button="true" 
                    calendar-button-icon="fas fa-calendar-alt datepicker_icon"
                  />
                </div>
                <div class="form-group col-md-3">
                  
                  <button
                  class="btn btn-primary rounded mt-4"
                  type="button"
                  :disabled="isDisabled || loading"
                  @click="checkCusipExist()"
                >
                  <span v-if="!loading">Calculate</span>
                  <span v-else>
                    <i class="fa fa-spinner fa-spin mr-1"></i> Loading...
                  </span>
                </button>
                </div>
              </div>

             
            </div>
          </div>

          <!-- RESULT -->
          <div v-if="result" class="card mt-4 shadow ">
            <div class="card-header bg-transparent d-flex justify-content-between">
              <h5 class="mb-0">Result</h5>
           
            </div>

            
            <div class="card-body">
              <div class="row">
                <!-- <div class="col-md-4 mb-3">
                  <small class="text-muted">CUSIP</small>
                  <div class="font-weight-bold">{{ result.cusip }}</div>
                </div> -->
                <div class="col-md-4 mb-3">
                  <small class="text-muted">De Minimis Status</small>
                  <div class="font-weight-bold">{{ result.deminisisStatus ? 'Yes' : 'No' }}</div>
                </div>

                <div class="col-md-4 mb-3">
                  <small class="text-muted">De Minimis Price</small>
                  <div>{{ result.deMinimisThresholdPrice | currency }}</div>
                </div>

               <!-- <div class="col-md-4 mb-3">
                  <small class="text-muted">Market Discount</small>
                  <div>{{ formatMarketDiscount(result.marketDiscount) }}</div>
                </div>


                <div class="col-md-4 mb-3">
                  <small class="text-muted">Pre Tax Gain</small>
                  <div>{{ result.preTaxGain }}</div>
                </div>

                <div class="col-md-4 mb-3">
                  <small class="text-muted">After Tax Gain</small>
                  <div>{{ result.afterTaxGain }}</div>
                </div> -->

                <!-- <div class="col-md-4 mb-3">
                  <small class="text-muted">Tax Liability</small>
                  <div>{{ result.taxLiability }}</div>
                </div>

                <div class="col-md-4 mb-3">
                  <small class="text-muted">Pre Tax Yield</small>
                  <div>{{ result.preTaxYield }}%</div>
                </div>

                <div class="col-md-4 mb-3">
                  <small class="text-muted">After Tax Yield</small>
                  <div>{{ result.afterTaxYield }}%</div>
                </div> -->

                <!-- <div class="col-md-4 mb-3">
                  <small class="text-muted">Tax Type</small>
                  <div>{{ result.taxType }}</div>
                </div> -->
<!-- 
                <div class="col-md-4 mb-3">
                  <small class="text-muted">Tax Treatment</small>
                  <div>{{ result.taxTreatment }}</div>
                </div> -->

              </div>
            </div>
          </div>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
import config from '@/config'
import authService from '@/authService'
import Datepicker from 'vuejs-datepicker'

export default {
  name: 'TaxCalculatorComponent',
  components: {
    Datepicker
  },
  data () {
    return {
      form: {
        cusip: '',
        price: null,
        ordinaryRate: null,
        capitalRate: null,
        settlementDate: null
      },
      result: null,
      loading: false,
      isExport: false
    }
  },

  computed: {
    isDisabled () {
      return (
        !this.form.cusip ||
        !this.form.price ||
        !this.form.settlementDate
      )
    }
  },

  methods: {
      checkCusipExist() {
        const auth = {
            headers: {'org-token' : authService.getOrgToken() }
        };
        this.$http
            .get(
            config.baseUrlBidSide +
            "/cusip/isExist?cusip=" + this.form.cusip.trim(),
            auth
            )
              .then(response => {
                   if(response.data === "NOTEXISTS"){
                        this.$alert("CUSIP does not exist.","","error");
                        this.form.cusip = '';
                        return;
                    }else{
                        this.fetchTaxDetails();

                    }
              })

           
        },
     getOrganizationSetting(){
            const auth = {
              headers: {'org-token' : authService.getOrgToken() }
            };
            this.$http
              .get(
                config.baseUrlBidSide +
                "/organization/bid-settings?type=OFFER",
                auth
              )
              .then(response => {
                this.form.settlementDate = response.data.settlementDate;
              })
        },
    exportData() {
      this.isExport = true;
      const auth = {
        headers: { 'org-token': authService.getOrgToken() }
      };
      let data = {
          "cognitoSub": authService.getUser().cognitoSub,
          "fileType": "pdf",
          "cusipList": [
            {
              "cusip": this.result.cusip,
              "deMinimisThresholdPrice": this.result.deMinimisThresholdPrice,
              "marketDiscount": this.result.marketDiscount,
              "deminisisStatus": this.result.deminisisStatus,
              "preTaxGain": this.result.preTaxGain,
              "afterTaxGain": this.result.afterTaxGain,
              "taxLiability": this.result.taxLiability,
              "preTaxYield": this.result.preTaxYield,
              "afterTaxYield": this.result.afterTaxYield,
              "taxTreatment": this.result.taxTreatment,
              "taxType": this.result.taxType,
              "adjustedIssuePrice": this.result.adjustedIssuePrice,
              "ordinaryRate": this.result.ordinaryRate,
              "capitalRate": this.result.capitalRate,
              "oid": this.result.oid,
            }
          ]
        }
      this.$http
        .post(
          config.baseUrlAutoBidder +
          "/cusip/tax-download", data,
          auth
        )
        .then((response) => {
          this.isExport = false;
          if(response.data){
              window.open(response.data, "_blank");
            }
          // this.$alert("Export is in progress, download file from File Logs once completed", "", "success");

        })
        .catch(e => {
          console.log(e);
          this.isExport = false;
        });
    },
    formatMarketDiscount(value) {
     return value <= 0 ? 'NO' : value
    },
    fetchTaxDetails () {
      const auth = {
        headers: { 'org-token': authService.getOrgToken() }
      }

      const settlementDate = this.form.settlementDate
        ? this.moment(this.form.settlementDate).utc().format('YYYY-MM-DD')
        : ''

      this.loading = true

      this.$http.get(
        config.baseUrlAutoBidder + '/cusip/tax-calculator',
        {
          ...auth,
          params: {
            cusip: this.form.cusip,
            price: this.form.price,
            ordinaryRate: this.form.ordinaryRate,
            capitalRate: this.form.capitalRate,
            settlementDate
          }
        }
      )
      .then(res => {
        this.result = res.data ? res.data.Details : null
      })
      .catch(err => {
        console.error(err)
        this.$notify({
          type: 'error',
          text: 'Failed to fetch tax details'
        })
      })
      .finally(() => {
        this.loading = false
      })
    }
  },
  mounted() {
    this.getOrganizationSetting();
  }

}

</script>

<style scoped>
.card {
  border-radius: 10px;
}

button.btn {
  min-width: 180px;
}

.text-muted {
  font-size: 12px;
}
</style>